import { ModuleProps, CreateModuleProps } from "components";
import { Routes } from "./Routes";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "PILOT_PEC_EXAM_EVALUATIONS",
    applicationRights: Rights,
    title: 'Evalueringer',
    text: 'Evalueringer',
    icon: 'note-pencil',
    showOnDashboardByDefault: false,
    onlineOnly: false,
    url: "/evaluation",
    sequenceNo: 11000,
    routes: Routes
})
